import Vue from 'vue';
import * as types from '@/store/mutationTypes';
import API from '@/api';
import { getField, updateField } from 'vuex-map-fields';
import { UserRole, UserPerm } from '@/types';
import { get, flatten, includes } from 'lodash';

const state = {
  userProfile: {},
  userInfo: {
    medicalExpires: '',
    cdlExpires: '',
    bqaCertification: {
      bqaId: null,
      documentUri: null,
      expires: null,
      verified: null,
    },
  },
};

const getters = {
  getField,
  isLtnAdmin: profilesState => get(profilesState, 'userProfile.roles', []).includes(UserRole.ROLE_LTN_ADMIN),
  findCompanyAccount: (profilesState) => {
    return (companyId) => {
      const companyAccounts = get(profilesState.userProfile, 'companyAccounts', []);
      const companyAccount = companyAccounts.find(acc => acc.companyId === companyId);
      if (!companyAccount) {
        return {};
      }
      return companyAccount;
    };
  },
  featureFlags: (profilesState) => {
    const userEmail = get(profilesState.userProfile, 'contactEmail', []);
    const whiteList = {
      loadsPage: ['timmy.garrabrant+10@gmail.com',
                  'usused feature flag',
                 ],
      quickbooks: ['timmy.garrabrant+10@gmail.com',
                   'usused feature flag',
                  ],
      transactionsV2: [
        'usused feature flag',
      ],
    };

    return {
      loadsPage: whiteList.loadsPage.includes(userEmail.toLowerCase()),
      quickbooks: whiteList.quickbooks.includes(userEmail.toLowerCase()),
      transactionsV2: whiteList.transactionsV2.includes(userEmail.toLowerCase()),
    };
  },
};

const mutations = {
  [types.SET_USER_PROFILE](profilesState, profile) {
    // eslint-disable-next-line no-param-reassign
    Vue.set(profilesState, 'userProfile', profile);
    if (get(profile, 'userInfo.driverProfile', false)) {
      window.__insp.push(['tagSession', { userType: 'driver' }]);
    } else {
      const perms = flatten(profile.companyAccounts.map(account => account.companyPermissions));
      if (includes(perms, UserPerm.PERM_ADMIN)) {
        window.__insp.push(['tagSession', { userType: 'admin' }]);
      } else if (includes(perms, UserPerm.PERM_OFFICE) ||
        includes(perms, UserPerm.PERM_DISPATCH) ||
        includes(perms, UserPerm.PERM_SCHEDULER)) {
        window.__insp.push(['tagSession', { userType: 'office' }]);
      }
    }
  },
  [types.CLEAR_PROFILES_MODULE](profilesState) {
    // eslint-disable-next-line no-param-reassign
    profilesState.userProfile = {};
  },
  [types.SET_USER_INFO](profilesState, profile) {
    // eslint-disable-next-line no-param-reassign
    profilesState.userInfo = profile;
    if (!profilesState.userInfo.driverProfile) {
      // eslint-disable-next-line no-param-reassign
      profilesState.userInfo.driverProfile = { medicalExpires: null, cdlExpires: null };
    }

    if (!profilesState.userInfo.bqaCertification) {
      // eslint-disable-next-line no-param-reassign
      profilesState.userInfo.bqaCertification = {
        bqaId: null,
        documentUri: null,
        expires: null,
        verified: null,
      };
    }
  },
  updateField,
};

const actions = {
  clear({ commit }) {
    commit(types.CLEAR_PROFILES_MODULE);
  },
  getUserProfile({ commit }) {
    return new Promise((resolve, reject) => {
      try {
        API.user.getProfile().then((response) => {
          commit(types.SET_USER_PROFILE, response.data);
          resolve(response);
        });
      } catch (error) {
        console.error('Failed to get profile', error);
        reject(error);
      }
    });
  },
  async updateUser({ commit }, params) {
    const response = await API.user.update(params);
    commit(types.SET_USER_PROFILE, response.data);
  },
  async getUser({ commit }, params) {
    let response;
    if (get(params, 'userId', false)) {
      response = await API.user.getUserProfile({ userId: params.userId });
    } else {
      response = await API.user.getProfile();
    }

    commit(types.SET_USER_INFO, response.data);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/profiles.js